module.exports = __webpack_public_path__ + "img/logo-sd-sc.251e009e.png";